<script>
/* eslint-disable no-unreachable */
/* eslint-disable no-unused-vars */
/* eslint-disable no-empty */
/* eslint-disable no-console */
import {
  urlMethods,
} from "@/state/helpers";
import Swal from "sweetalert2";
import _ from 'lodash';
export default {
    components: {},
    data: function () {
        return {
            cashierID: 0,
            isLoading: false,
            currentID: 0,
            cashierSearchs: [],
            searchSelected: {},
            isShowCasherPopup: false,
        }
    },
    computed: {
        currentUser: function(){
            return this.$store.getters['auth/currentUser'];
        },
        currentTab: function(){
            return this.$store.getters['sale/currentTab'];
        },
        cashiers: function(){
            let cashiers = this.$store.getters['sale/cashier'];
            return JSON.parse(JSON.stringify(cashiers));
        },

    },
    methods: {
        ...urlMethods,
        setCurrentID(item){
            for(let i = 0; i < this.cashiers.length ; i++){
                if(this.cashiers[i].id == item.id){
                    this.currentID = i;
                }
            }
        },
        setCashier(item, hide = true){
            this.cashierID = item.id;
            this.$store.dispatch("sale/setCashierSelected",item);
            if(hide) this.$bvModal.hide('modal-cashier');
            else this.setCurrentID(item);
        },
        setsearchSelected(){
            this.cashierID = 0;
            this.$store.dispatch("sale/setCashierSelected",this.searchSelected);
            this.$bvModal.hide('modal-cashier');
            this.$bvModal.hide('modal-cashier-other');
        },
        searchOther(){
            this.$bvModal.hide('modal-cashier');
            this.$bvModal.show('modal-cashier-other');
            setTimeout(() => {
                this.$refs.searchSelected.searchEl.focus();
            }, 100);
        },
        asyncFind(search, loading) {
            if(search.length) {
                loading(true);
                this.search(loading, search, this);
            }
        },
        search: _.debounce(async (loading, query, that) => {
            try {
                let res = await that.postUrl({'url' : 'search-cashier', 'data' : {'name': query}});
                if(typeof res == 'undefined' || typeof res.data == 'undefined'){
                    throw 'Không thế kết nối server';
                }
                if(!res.data){
                    that.cashierSearchs = [];
                }else{
                    that.cashierSearchs = JSON.parse(JSON.stringify(res.data));
                }
            } catch (error) {
                console.log(error);
                let text = (typeof error  == 'string' ? error : JSON.stringify(error));
                that.$store.dispatch("sale/setNoti", { 'text' :  text, 'type' : 'error'});
            }
            loading(false);
        }, 500)
    },
    mounted() {
        let that = this;
        this.$root.$on('bv::modal::show', (bvEvent, modalId) => {
            if(modalId == 'modal-cashier'){
                that.isShowCasherPopup = true;
                if(typeof that.currentTab.info != 'undefined' && typeof that.currentTab.info.nvbh != 'undefined' && typeof that.currentTab.info.nvbh.id != 'undefined'){
                    that.cashierID = that.currentTab.info.nvbh.id;
                    that.setCurrentID(that.currentTab.info.nvbh);
                }
            }
        });
        this.$root.$on('bv::modal::show', (bvEvent, modalId) => {that.isShowCasherPopup = false;});
        this.$mousetrap.bind('down', function(e) {
            e.preventDefault();
            if(that.isShowCasherPopup && typeof that.currentID != 'undefined'){
                that.currentID++;
                if(that.currentID >= that.cashiers.length){
                    that.currentID = 0;
                }
                if(typeof that.cashiers[that.currentID] != 'undefined') that.setCashier(that.cashiers[that.currentID],false);
            }
            return false;
        });
        this.$mousetrap.bind('up', function(e) {
            e.preventDefault();
            if(that.isShowCasherPopup && typeof that.currentID != 'undefined'){
                that.currentID--;
                if(that.currentID < 0){
                    that.currentID = that.cashiers.length > 0 ? that.cashiers.length - 1 : 0;
                }
                if(typeof that.cashiers[that.currentID] != 'undefined') that.setCashier(that.cashiers[that.currentID],false);
            }
            return false;
        });
        this.$mousetrap.bind('enter', function(e) {
            e.preventDefault();
            if(that.isShowCasherPopup && typeof that.currentID != 'undefined'){
                that.$bvModal.hide('modal-cashier');
            }
            return false;
        });
    },
};
</script>

<template>
<div>
<b-modal id="modal-cashier" title="Chọn nhân viên bán hàng" title-class="font-18" hide-footer>
    <div class="btn-group-vertical" role="group" style="width: 100%">
        <div style="width: 100%; margin-bottom: 5px;" v-for="item in cashiers" :key="item.id">
            <input type="radio" class="btn-check" @click="setCashier(item)" v-model="cashierID" :id="'btn-set-cashier-'+item.id" :value="item.id" />
            <label style="width: 100%; margin-bottom: 10px;" class="btn btn-outline-info mb-0" :for="'btn-set-cashier-'+item.id">{{item.name}}</label>
        </div>
    </div>
    <a class="mt-2" style="display: inline-block;cursor: pointer; text-decoration: underline !important; color: #50a5f1" @click="searchOther">Chọn từ siêu thị khác</a>
</b-modal>
<b-modal id="modal-cashier-other" title="Tìm NVBH từ siêu thị khác" title-class="font-18" hide-footer>
    <b-form-group class="mb-3" label-cols-lg="3" label="Tìm kiếm" label-for="searchSelected">
        <v-select ref="searchSelected" v-model="searchSelected" @input="setsearchSelected" label="Nhân viên bán hàng" :filterable="false" :options="cashierSearchs" @search="asyncFind">
            <template slot="no-options">Nhập tên nhân viên bán hàng để tìm</template>
            <template slot="option" slot-scope="option">{{ option.name }}</template>
            <template slot="selected-option" slot-scope="option">{{ option.name }}</template>
        </v-select>
    </b-form-group>
</b-modal>
</div>
</template>
